import { mapMimeTypeToGeneralType } from '../../../helpers'
import moment from 'moment'

const adminTable = (document) => {
  return {
    id: document.id,
    title: document.title,
    description: document.description,
    path: document.path,
    url: document.url,
    mime_type: mapMimeTypeToGeneralType(document.mime_type),
    size: document.size,
    status: document.status,
    submitter: document.submitter,
    created: moment(document.created_at).unix(),
    reviewer: document.reviewer,
    downloaded: moment(document.downloaded_at).unix(),
    updated: moment(document.updated_at).unix()
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  view (state) {
    return (view) => {
      return state.views[view].ids.map((id) => state.views[view].index[id]).map(adminTable)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bioreq/getters.js